// @flow

import React, { Component } from 'react'
import styled from 'styled-components'

import Header from './Header'
import Nav from './Nav'
import Books from './Books'

const Root = styled.div`
  padding: 0 15px;
`

const bookLocales = [
  'ru',
  'en',
  'ua',
  'hw',
  'de',
  'cn',
  'mg',
  'ar',
  'tb',
  'jp',
];

class App extends Component {
  render() {
    return (
      <Root>
        <Header />
        <Nav />
        <Books
          bookLocales={bookLocales}
        />
      </Root>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js